export default function CTA() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Imagen de fondo con overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e743d6e7207b3bb05293b079771ba590.jpg"
          alt="Workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-pink-500/90 via-purple-600/85 to-pink-500/90"></div>
      </div>

      {/* Contenido */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-wide">
          ¿LISTA PARA LLEVAR TU MARCA AL SIGUIENTE NIVEL?
        </h2>
        <p className="text-xl md:text-2xl text-white/95 mb-12 leading-relaxed">
          Agenda tu asesoría gratuita y descubre cómo potenciar tu presencia digital
        </p>

        <a
          href="https://wa.me/message/RKPZLG3TDGMLD1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-4 px-10 py-5 bg-white text-purple-700 font-bold text-lg rounded-full shadow-2xl shadow-pink-500/50 hover:scale-105 hover:shadow-3xl transition-all cursor-pointer whitespace-nowrap"
        >
          <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center">
            <i className="ri-whatsapp-line text-xl text-white"></i>
          </div>
          <span>CONTÁCTAME AHORA</span>
          <i className="ri-arrow-right-up-line text-2xl"></i>
        </a>

        {/* Elementos decorativos */}
        <div className="mt-16 flex items-center justify-center gap-12 text-white/80">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm font-medium">Asesoría gratuita</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm font-medium">Sin compromiso</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm font-medium">Respuesta rápida</span>
          </div>
        </div>
      </div>
    </section>
  );
}
